export const DEFAULT_LOGIN_ERROR_MESSAGE = 'Login failed. Please contact support at pricingassistant@talkfurther.com';
export const UNAUTHORIZED_LOGIN_ERROR_MESSAGE = 'Your login info is incorrect.';
export const INVALID_EMAIL = 'Enter a valid email address';
